module.exports = __webpack_public_path__ + "static/media/GetAlerts.7804476a.svg";